import {
    Component,
    ComponentFactory,
    ComponentFactoryResolver,
    ComponentRef,
    ElementRef,
    Input,
    OnInit,
    Type,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import { ValueService } from '../../services/value.service';

@Component({
    selector: 'chassis-datatable-value',
    templateUrl: './value.component.html',
    styleUrls: ['./value.component.scss'],
})
export class ValueComponent implements OnInit {

    @Input() name: string;

    @Input() data: any;

    /**
     * The ViewContainerRef instance.
     */
    @ViewChild('content', {read: ViewContainerRef}) content: ViewContainerRef;

    constructor(
        protected componentFactoryResolver: ComponentFactoryResolver,
        protected valueService: ValueService,
        protected elementRef: ElementRef
    ) {
        //
    }

    /**
     * Get the native element of the action.
     * Used to calculate the actions width.
     */
    public get element(): HTMLElement {
        return this.elementRef.nativeElement;
    }

    public ngOnInit(): void {
        const component = this.getComponent();

        // Cancel when no filter component is registered.
        if (!component) {
            return;
        }
        const componentFactory = this.createComponentFactory(
            component
        );

        const componentRef = this.createComponentRef(
            componentFactory,
        );

        const instance = componentRef.instance;

        this.bindProperties(instance);
    }

    protected getComponent(): Type<any> | null {
        return this.valueService.get(
            this.name
        );
    }

    protected createComponentFactory(component: Type<any>): ComponentFactory<any> {
        return this.componentFactoryResolver.resolveComponentFactory(
            component,
        )
    }

    protected createComponentRef(factory: ComponentFactory<any>): ComponentRef<any> {
        return this.content.createComponent(
            factory,
        )
    }

    protected bindProperties(instance: Component): void {
        instance['data'] = this.data;
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/components/value/value.component.ts